import { render, staticRenderFns } from "./shipout-done.vue?vue&type=template&id=121e5e81&scoped=true"
import script from "./shipout-done.vue?vue&type=script&lang=js"
export * from "./shipout-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e5e81",
  null
  
)

export default component.exports